// this is an autogenerated file from App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/ActionsColumn/ToggleLocationConnection/SetupAutomations/Content/Content/mutation-update-preferences.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_ConnectApps_App_Content_Connections_Content_ActionsColumn_ToggleLocationConnection_SetupAutomations_Content_Content(
  $connection_id: uuid!
  $resource_id: uuid!
  $properties: jsonb!
) {
  insert_apps_connection_resources_one(
    object: {
      connection_id: $connection_id
      properties: $properties
      resource_id: $resource_id
      status: created
    }
    on_conflict: {
      constraint: connection_resources_connection_id_resource_id_key
      update_columns: properties
    }
  ) {
    id
  }
}

`